import { render, staticRenderFns } from "./AddressFieldGroup.vue?vue&type=template&id=540d8fef&"
import script from "./AddressFieldGroup.vue?vue&type=script&lang=js&"
export * from "./AddressFieldGroup.vue?vue&type=script&lang=js&"
import style0 from "./AddressFieldGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports